import React from 'react';

const Files: React.FC = () => {
    return (
        <div>
            <h1>Files Page</h1>
            <p>This is the Files page content.</p>
        </div>
    );
};

export default Files;